import * as React from 'react';
import { useAccountPositionsSAccIsin } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountsPositionsSAccIsin = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsSAccIsin();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
